module.exports = __webpack_public_path__ + "static/tuzagTailor-fe239d59b638dca1f73c8d3e63557652.svg";